/**
 *  Possible type of an event.
 */
export var EventType;
(function (EventType) {
    EventType[EventType["Once"] = 0] = "Once";
    EventType[EventType["Repeating"] = 1] = "Repeating";
})(EventType || (EventType = {}));
/**
 *  Possible status of an event.
 */
export var EventStatus;
(function (EventStatus) {
    EventStatus["Unavailable"] = "unavailable";
    EventStatus["Available"] = "available";
    EventStatus["Sold_out"] = "sold_out";
    EventStatus["Refunding"] = "refunding";
    EventStatus["Moving"] = "moving";
})(EventStatus || (EventStatus = {}));
/**
 *  The possible types of a product.
 */
export var ProductType;
(function (ProductType) {
    ProductType[ProductType["Normal"] = 0] = "Normal";
    ProductType[ProductType["Varying"] = 1] = "Varying";
})(ProductType || (ProductType = {}));
/**
 *  The possible methods of a product.
 */
export var ProductMethod;
(function (ProductMethod) {
    ProductMethod["BookingProtect"] = "bookingProtect";
})(ProductMethod || (ProductMethod = {}));
/**
 *  The possible pricing methods of a product.
 */
export var PricingMethod;
(function (PricingMethod) {
    PricingMethod["Own"] = "own";
    PricingMethod["Container"] = "container";
})(PricingMethod || (PricingMethod = {}));
/**
 *  Type of the product group. This value translates
 *  to the type of input that shops will render for
 *  selecting the products in this group.
 */
export var ProductGroupType;
(function (ProductGroupType) {
    ProductGroupType["Required"] = "required";
    ProductGroupType["Optional"] = "optional";
    ProductGroupType["Select"] = "select";
    ProductGroupType["Radio"] = "radio";
    ProductGroupType["Multiselect"] = "multiselect";
    ProductGroupType["Checkbox"] = "checkbox";
})(ProductGroupType || (ProductGroupType = {}));
/**
 *  The possible types of event selection.
 */
export var EventSelection;
(function (EventSelection) {
    EventSelection["Auto"] = "auto";
    EventSelection["Enabled"] = "enabled";
    EventSelection["Disabled"] = "disabled";
})(EventSelection || (EventSelection = {}));
//# sourceMappingURL=types.js.map